import BaseModel from '../../../base';
import TeamPattern from '..';

export default class TeamPatternRight extends BaseModel {
  constructor(right = {}, url = 'team-pattern-rights') {
    super(right, url);

    Object.assign(this, right);

    this.team_pattern_id = right.team_pattern_id ?? null;
    this.event_id = right.event_id ?? null;
    this.team_pattern = right.team_pattern
      ? new TeamPattern(right.team_pattern)
      : null;
  }
}
